// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import set from 'lodash4/set.js';
import email from '/util/email.js';
import {is_http_url} from '/util/url.js';
import {
    FIELD_KIND,
    INVALID_URL_ERROR,
    INVALID_EMAIL_ERROR,
} from '@pub/shared/constants.js';
import {REQUIRED_ERROR} from './constants.js';

const PASSWORD_ERROR = {
    empty: 'Enter a password',
    short: 'Password is too short',
    long: 'Password is too long',
    simple: 'Password should contain digits, upper and lower case English '
        +'letter and at least one special character.',
    email_like: 'Password should not contain email address',
};
const LEN_ERROR = x=>`Value should not be longer than ${x} symbols`;

export const get_password_error = (pass, validate)=>{
    const res = validate(pass);
    if (!res)
        return null;
    return PASSWORD_ERROR[res];
};

export const get_url_error = (u, valid_with)=>{
    if (u==valid_with)
        return null;
    return !!u&&!is_http_url(u) ? INVALID_URL_ERROR : null;
};

export const get_email_error = (u, valid_with)=>{
    if (u==valid_with)
        return null;
    return !!u&&!email.is_valid(u) ? INVALID_EMAIL_ERROR : null;
};

export const get_len_error = (value, max_len)=>{
    if (value.length>max_len)
        return LEN_ERROR(max_len);
    return null;
};

export const some_required = (required_fields=[])=>{
    const required_map = required_fields.reduce((acc, field)=>{
        acc[field] = true;
        return acc;
    }, {});
    return form_data=>{
        const details = {};
        let valid = true;
        for (const key of Object.keys(form_data))
        {
            if (!required_map[key])
                continue;
            if (!form_data[key])
            {
                details[key] = REQUIRED_ERROR;
                valid = false;
            }
        }
        return {valid, details};
    };
};

export const all_required = form_data=>{
    const details = {};
    let valid = true;
    for (const key of Object.keys(form_data))
    {
        if (!form_data[key])
        {
            details[key] = REQUIRED_ERROR;
            valid = false;
        }
    }
    return {valid, details};
};

const gather_array = (array_field, content, default_val=[])=>{
    const item_prefix = array_field+'.';
    const list = [];
    for (const key in content)
    {
        if (key.startsWith(item_prefix))
        {
            const [, suffix] = key.split(item_prefix);
            const index = parseInt(suffix, 10);
            if (typeof index == 'number' && !isNaN(index))
                list[index] = content[key];
        }
    }
    return list.length ? list : default_val;
};

const guess_array = (field, content)=>{
    if (content[field])
        return false;
    for (let i=0; i<5; i++)
    {
        if (content[`${field}.${i}`])
            return true;
    }
    return false;
};

export const pick_value = (content, field, default_val='')=>{
    if (guess_array(field, content))
        return gather_array(field, content, default_val);
    return content[field] ?? default_val;
};

export const is_required_set = (content, meta)=>{
    for (const k of Object.keys(meta))
    {
        const c = pick_value(content, k);
        const m = meta[k];
        if (!m.required)
            continue;
        if (Array.isArray(c))
        {
            if (!c.length)
                return false;
        }
        else if (m.kind==FIELD_KIND.BOOLEAN)
        {
            if (m.true_only && !c)
                return false;
            if (typeof c != 'boolean')
                return false;
        }
        else if (!c)
            return false;
    }
    return true;
};

const unfold_array = (key, list)=>list.reduce((acc, item, i)=>{
    acc[`${key}.${i}`] = item;
    return acc;
}, {});

export const flatten_content = obj_c=>{
    const res = {};
    for (const i in obj_c)
    {
        const v = obj_c[i];
        if (Array.isArray(v))
        {
            const unfolded = unfold_array(i, v);
            for (const x in unfolded)
                res[x] = unfolded[x];
        }
        else if (typeof v=='object' && v!==null && !(v instanceof Date))
        {
            const f_obj = flatten_content(v);
            for (const x in f_obj)
                res[`${i}.${x}`] = f_obj[x];
        }
        else
            res[i] = v;
    }
    return res;
};

export const compile_content = content=>{
    const res = {};
    for (const [field_path, value] of Object.entries(content))
    {
        if (value===undefined)
            continue;
        set(res, field_path, value);
    }
    return res;
};
